import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../services/api';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/pt-br';
import 'react-big-calendar/lib/css/react-big-calendar.css';

// Configurar moment para português brasileiro
moment.locale('pt-br');
const localizer = momentLocalizer(moment);

export default function CalendarioEventos() {
    const [eventosCalendario, setEventosCalendario] = useState([]);
    const [carregandoCalendario, setCarregandoCalendario] = useState(true);
    const token = localStorage.getItem('token');
    const history = useHistory();

    const buscarEventosCalendario = useCallback(async () => {
        try {
            setCarregandoCalendario(true);
            const response = await api({
                method: 'get',
                action: '/evento/eventosCalendario',
                token: token,
            });

            if (response.data.status === true) {
                setEventosCalendario(response.data.data);
            }
        } catch (error) {
            console.error('Erro ao buscar eventos do calendário:', error);
        } finally {
            setCarregandoCalendario(false);
        }
    }, [token]);

    const handleEventClick = (event) => {
        let url = `/evento?idEvento=${event.id}`;

        // Se o evento for fechado, adicionar parâmetro para abrir na aba fechados
        if (event.situacao === 'fechado') {
            url += '&situacao=fechado';
        }

        history.push(url);
    };

    useEffect(() => {
        buscarEventosCalendario();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="card">
            <div className="card-header">
                <h5 className="mb-0" style={{ padding: '10px' }}>
                    <i className="fa fa-calendar me-2" />
                    Calendário de Eventos
                </h5>
            </div>
            <div className="card-body">
                {carregandoCalendario ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Carregando...</span>
                        </div>
                        <p className="mt-2">Carregando calendário...</p>
                    </div>
                ) : (
                    <div style={{ height: '500px' }}>
                        <Calendar
                            localizer={localizer}
                            events={eventosCalendario}
                            startAccessor="start"
                            endAccessor="end"
                            onSelectEvent={handleEventClick}
                            views={['month', 'week', 'day']}
                            defaultView="month"
                            messages={{
                                next: "Próximo",
                                previous: "Anterior",
                                today: "Hoje",
                                month: "Mês",
                                week: "Semana",
                                day: "Dia",
                                noEventsInRange: "Não há eventos neste período."
                            }}
                            eventPropGetter={(event) => ({
                                style: {
                                    backgroundColor: event.backgroundColor,
                                    borderColor: event.borderColor,
                                    color: event.textColor
                                }
                            })}
                            tooltipAccessor={(event) =>
                                `${event.title}\nCliente: ${event.cliente}\nCódigo: ${event.codigo}\nSituação: ${event.situacao}`
                            }
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

